import React from 'react';
import Dropdown from 'react-dropdown';
//import { IconInformation } from '../../img'; //IconDelete
import './Integration.scss';
import ContentLoader from 'react-content-loader';
import ReactTooltip from 'react-tooltip';
import IntHeader from './IntHeader';

const GooglePlace = ({
  data,
  loading,
  hideShowDataSource,
  // arrDataSource,
  // handleDataSource,
  userIntegration,
  createGooglePlace,
  deleteGooglePlace,
  //handleIsActive,
  handleStateChangeInt,
  handleStateChangeDrpDOWN,
  validator,
  //hideShowIntegration,
  openReviewModel,
  intInterValFn
}) => {
  if (userIntegration && userIntegration.length > 0) {
    userIntegration.filter(x => {
      if (x.inm === 'google') {
        if (x.d && x.d.isListen === true && data.isCallInterVal === false) {
          intInterValFn();
        }
        return x;
      }
    });
  }
  const optionsLG = [
    { value: 'en', label: 'English' },
    { value: 'af', label: 'Afrikaans' },
    { value: 'ar', label: 'Arabic' },
    { value: 'zh-CN', label: 'Chinese(Simplified)' },
    { value: 'zh-TW', label: 'Chinese(Traditional)' },
    { value: 'nl', label: 'Dutch' },
    { value: 'et', label: 'Estonian' },
    { value: 'fr', label: 'French' },
    { value: 'de', label: 'German' },
    { value: 'el', label: 'Greek' },
    { value: 'iw', label: 'Hebrew' },
    { value: 'hi', label: 'Hindi' },
    { value: 'hu', label: 'Hungarian' },
    { value: 'id', label: 'Indonesian' },
    { value: 'it', label: 'Italian' },
    { value: 'ja', label: 'Japanese' },
    { value: 'ko', label: 'Korean' },
    { value: 'pl', label: 'Polish' },
    { value: 'pt', label: 'Portuguese(Portugal, Brazil)' },
    { value: 'ru', label: 'Russian' },
    { value: 'sk', label: 'Slovak' },
    { value: 'sl', label: 'Slovenian' },
    { value: 'es', label: 'Spanish' },
    { value: 'sv', label: 'Swedish' },
    { value: 'ta', label: 'Tamil' },
    { value: 'th', label: 'Thai' },
    { value: 'tr', label: 'Turkish' },
    { value: 'uk', label: 'Ukrainian' },
    { value: 'ur', label: 'Urdu' },
    { value: 'vi', label: 'Vietnamese' }
  ];
  return (
    <div>
      <div className="title-dataset-select">
        <IntHeader
          data={data}
          hideShowDataSource={hideShowDataSource}
        />
        {/* <div className="dataset-select-header" >
          <div className="title-dataset-label cursor" onClick={() => hideShowDataSource()}>
            <img className="mr-2" src={data.img} alt="icon" />
            <h6>{data.dn}</h6>
          </div>
          <svg onClick={() => hideShowDataSource()} className="link-svg" xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7.197">
            <path id="Icon_ionic-ios-arrow-down" data-name="Icon ionic-ios-arrow-down" d="M6,2.17,10.54,6.933a.826.826,0,0,0,1.211,0,.939.939,0,0,0,0-1.274L6.61.262A.827.827,0,0,0,5.427.236L.25,5.655a.936.936,0,0,0,0,1.274.826.826,0,0,0,1.211,0Z" transform="translate(12 7.197) rotate(180)"></path>
          </svg>
        </div> */}
        {/* {userIntegration && userIntegration.length > 0 && data.isHideShowInt == false && 
        <div className="integr-inside-hdright" onClick={() => hideShowIntegration()}>
          <div className="add-integra-btn text-center" >
            <a className="nf-btn tbl-seehty-btn">Add New </a>
          </div>
        </div>
        } */}
        {/* {((typeof userIntegration == 'undefined' || typeof userIntegration == 'boolean')) &&  */}
        <div className="wdgt-group-block wdgt-dataset-form  wdgt-group-ggplace">
          <div className="wdgt-group-input">
            <label className="d-flex">Place ID
              <div className="connect-list-tooltip">
                <svg id="Group_8490" data-tip data-for="placeid" data-name="Group 8490" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                  <circle fill="#C1CDDB" id="Ellipse_179" data-name="Ellipse 179" cx="0.775" cy="0.775" r="0.775" transform="translate(7.225 11.056)" />
                  <path fill="#C1CDDB" id="Path_14205" data-name="Path 14205" d="M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0ZM8,14.75A6.75,6.75,0,1,1,14.75,8,6.746,6.746,0,0,1,8,14.75Z" />
                  <path fill="#C1CDDB" id="Path_14206" data-name="Path 14206" d="M178.48,128.5a2.483,2.483,0,0,0-2.48,2.48.62.62,0,1,0,1.24,0,1.24,1.24,0,1,1,1.24,1.24.62.62,0,0,0-.62.62v1.55a.62.62,0,1,0,1.24,0v-1.009a2.481,2.481,0,0,0-.62-4.882Z" transform="translate(-170.48 -124.463)" />
                </svg>
                {/* <img data-tip data-for="placeid" src={IconInformation} alt="" /> */}
                <ReactTooltip id="placeid" aria-haspopup='true' role='example'>
                  <p>Test</p>
                </ReactTooltip>
              </div>
            </label>
            <input className="nf-input nf-input-sm" name="place_id" placeholder="Enter Place ID" value={data.place_id} onChange={handleStateChangeInt} />
            {validator.message('place id', data.place_id, 'required|required')}
          </div>
          <div className="wdgt-group-input mt-15">
            <label className="">Enter Company name</label>
            <input className="nf-input nf-input-sm" name="rmk" value={data.rmk} placeholder="Enter Company name" onChange={handleStateChangeInt} />
            {validator.message('Company name', data.rmk, 'required|required')}
          </div>
          <div className="wdgt-group-input mt-15">
            <label className="">Select language</label>
            <Dropdown className="nf-select-dropdown nf-select-defaultdd nf-select-langudd" value={data.lng} options={optionsLG} name="lng"
              onChange={(e) => handleStateChangeDrpDOWN(e, 'lng')} />
            {validator.message('language', data.lng, 'required|required')}
          </div>
          <div className="add-integra-btn text-center" onClick={(e) => createGooglePlace(e)}>
            <a className="nf-btn nf-btn-default">Add New</a>
          </div>
        </div>
        {/* {userIntegration && userIntegration.length > 0 && 
        <div className="integre-search--list">
          <input
            className="nf-input nf-input-sm input-left-inicon input-left-iconsearch input-left-visitor"
            placeholder="Search by name"
            type="text"
            name="searchByName"
            value={data.searchByName}
            onChange={(e) => handleStateChangeInt(e)}
          />
        </div>} */}
        {loading === true ?
          <ContentLoader
            height={750}
            width={1750}
            speed={2}
            primaryColor="#fff"
            secondaryColor="#eceef4"
          >
            <rect x="150" y="40" rx="0" ry="0" width="1500" height="700"></rect>
          </ContentLoader> :
          <div className='sublistapp-connect-block'>
            <h5 className='title-connection'>Place ID list</h5>
            <div className='app-list-sublistapp'>
              <div className='integra-data-headerblock'>
                <label className=''>Name</label>
                <label className=''>Action</label>
              </div>
              <div className='review-collection-scroll' style={{ height: 'calc(100vh - 480px)' }}>
                {userIntegration && userIntegration.length > 0 ?
                  userIntegration.map((usInt, key) => {
                    if (usInt._id == data.usIntId) usInt.ia = data.intISActive ? data.intISActive : false;
                    // let defaultChecked = arrDataSource.filter((dataSource) => {
                    //   if (dataSource.uid == usInt._id && dataSource.pid == usInt._id) return true; return false;
                    // }).length > 0 ? true : false;
                    // let objCountParams = {
                    //   pglkcnt: 0,
                    //   pgflcnt: 0,
                    //   pgrtngcnt: usInt.d.rati_count,
                    //   pgrtngavg: usInt.d.avg_rati,
                    //   pu: usInt.d.place_id,
                    //   iin: usInt.inm,
                    //   rmk: usInt.rmk,
                    //   dn: usInt.d.dn ? usInt.d.dn : ''
                    // };
                    return (new RegExp(data.searchByName, 'i').test(usInt.rmk) == true && <div className="card-editor card-intigra-block card-intigra-ggpalceislist" key={key}>
                      <div className="integra-checklist-item" >
                        {/* <div className="secstyle-checkbox secstyle-checkbox-sm  itgtion-icon-checkboc " style={{ display: 'none' }}>
                      <label>
                        <input type="checkbox"
                          name={usInt.d.place_id}
                          checked={defaultChecked}
                          onChange={(e) => handleDataSource(
                            usInt._id,
                            usInt._id,
                            e.target.checked,
                            objCountParams,
                            usInt
                          )}
                        />
                      </label>
                    </div> */}
                        <span className="">{usInt.rmk}</span>
                        {/* <div className='card-intigra-block-action'> */}
                        {usInt.d.isListen === true &&
                          <span className='btn-action nf-btn light-bg-icon btn-icon-20 tbl-action-rotet'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 20 19.996">
                              <path id="Path_59553" data-name="Path 59553" d="M52,17.379v6.207a1.378,1.378,0,0,1-1.379,1.379H44.414a1.379,1.379,0,0,1,0-2.759h2.732a6.886,6.886,0,1,0-5.5,11.026,6.83,6.83,0,0,0,4.133-1.377,1.38,1.38,0,0,1,1.657,2.206A9.565,9.565,0,0,1,41.652,36a9.651,9.651,0,1,1,7.59-15.59V17.379a1.379,1.379,0,1,1,2.759,0Z" transform="translate(-32 -16)" fill="#8392a5" />
                            </svg>
                          </span>
                        }
                        {usInt.d.isListen === false &&
                          <span className="btn-action nf-btn light-bg-icon btn-icon-20  tbl-action-dlt"
                            onClick={() => openReviewModel(usInt)}>
                            {/* <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 14.233 14.164">
                        <path id="Path_240" data-name="Path 240" d="M-31.27,55.361l2.9,2.9L-35.7,65.586l-2.894-2.9Zm5.092-.7-1.291-1.291a1.281,1.281,0,0,0-1.81,0l-1.237,1.237,2.9,2.9,1.443-1.443a.987.987,0,0,0,0-1.4Zm-13.935,12.1a.329.329,0,0,0,.4.392l3.226-.782-2.894-2.9Zm0,0" transform="translate(40.12 -52.998)" fill="#b0bec5"></path>
                      </svg> */}
                            <svg xmlns="http://www.w3.org/2000/svg" width="12.414" height="7.4" viewBox="0 0 12.414 7.4">
                              <path id="Path_14253" data-name="Path 14253" d="M6.207,98.725A7.744,7.744,0,0,0,.1,102.13a.491.491,0,0,0,0,.587,7.74,7.74,0,0,0,6.11,3.408,7.744,7.744,0,0,0,6.11-3.405.491.491,0,0,0,0-.587A7.74,7.74,0,0,0,6.207,98.725Zm.17,6.305A2.611,2.611,0,1,1,8.812,102.6,2.613,2.613,0,0,1,6.377,105.03Zm-.079-1.2a1.406,1.406,0,1,1,1.313-1.313A1.4,1.4,0,0,1,6.3,103.827Z" transform="translate(0 -98.725)" fill="#8392a5" />
                            </svg>
                          </span>}
                        <span className="btn-action nf-btn  btn-delete-light  light-bg-icon btn-icon-20  tbl-action-dlt"
                          onClick={() => deleteGooglePlace(usInt._id)}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 176 192">
                            <g id="Group_8307" data-name="Group 8307" transform="translate(-8)">
                              <path id="Path_12759" data-name="Path 12759" d="M128,32V24A24.027,24.027,0,0,0,104,0H88A24.027,24.027,0,0,0,64,24v8H8V48H184V32ZM80,24a8.009,8.009,0,0,1,8-8h16a8.009,8.009,0,0,1,8,8v8H80Z" fill="#fb5360" />
                              <path id="Path_12760" data-name="Path 12760" d="M30.467,170.651A23.976,23.976,0,0,0,54.321,192h83.358a23.976,23.976,0,0,0,23.854-21.35L174.272,56H17.728Zm87.561-99.316,15.944,1.33-8,96-15.944-1.33Zm-44.056,0,8,96-15.944,1.33-8-96Z" fill="#fb5360" />
                            </g>
                          </svg>
                        </span>
                      </div>
                      {/* </div> */}
                    </div>);
                  }) : ''}
              </div>
            </div>
          </div>}
      </div>
    </div >
  );
};


export default GooglePlace;


// WEBPACK FOOTER //
// ./src/components/Integration/GooglePlace.js